import { keepPreviousData, useQuery } from '@tanstack/react-query';

import * as api from './api';

export function useIncome(params: api.IncomeListParams) {
  return useQuery({
    queryKey: ['income', 'list', params],
    queryFn: () => api.listIncome(params),
    placeholderData: keepPreviousData,
  });
}

export function useExpenses(params: api.ExpenseListParams) {
  return useQuery({
    queryKey: ['expenses', 'list', params],
    queryFn: () => api.listExpenses(params),
    placeholderData: keepPreviousData,
  });
}
